export default "__VITE_ASSET__Cq9FCClG__"